module.exports = __webpack_public_path__ + "static/media/Sink.81186e3a.png";